import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AdditionalProductsSummaryPoint, IERechnungsInfo, MandateSummary, TextNodeType } from '@mwe/models';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { NewBankAccountInfoTextsComponent } from '../../bank/new-bank-account-info-texts/new-bank-account-info-texts.component';
import { HeadlineComponent } from '../../headline/headline.component';
import { InfoboxComponent } from '../../infobox/infobox.component';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-products-summary-invoice-old',
  templateUrl: './products-summary-invoice-old.component.html',
  imports: [TranslateDirective, NewBankAccountInfoTextsComponent, TranslatePipe, HeadlineComponent, InfoboxComponent, SafeHtmlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsSummaryInvoiceOldComponent {
  isPaymentInfoVisible = input<any>();
  personalBillingTitle = input<string>();
  eRechnungInfo = input<IERechnungsInfo>();
  paymentIcon = input<string>();
  paymentText = input<string>();
  formattedAddress = input<string>();
  contactDataEmailAddress = input<string>();
  additionalBulletPoints = input<AdditionalProductsSummaryPoint[]>();
  areBankAccountInfoTextsVisible = input<boolean>();
  productCategories = input<string[]>();
  invoiceInfoAlertMessage = input<string>();
  paymentDataLabelClass = input<string>();
  eBillingLabelClass = input<string>();
  contactDataEmailAddressLabelClass = input<string>();
  summaryBillingTitleText = input<string>('summary.eBilling');
  billingAddressTitleText = input<string>(null);
  shippingEmailTitleText = input<string>(null);
  infoTextCardLabel = input<string>();
  hasSpotTariff = input<boolean>(false);
  headlineNodeType = input<TextNodeType>('h3');
  hideInvoiceAlert = input<boolean>(false);
  readonly stromGasMandate = input<MandateSummary>();
  readonly fernWaermeMandate = input<MandateSummary>();
}
